import React from 'react'
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import './DropdownSelection.css';

function DropdownSelection(props) {
  let { activeType, Types } = props;


  const types = Types.map((type) =>
    <DropdownItem
      key={`filter-type-${type.id}`}
      onClick={e => {
        e.preventDefault();
        props.filterType(type.id);
      }}
      active={type === type.display_name}
      disabled={props.disabled}
    >
      {type.display_name}
    </DropdownItem>
  );


  return (
    <UncontrolledDropdown>
      <DropdownToggle caret color="secondary" outline className="dropdown" >
        {activeType ? activeType : '全部分類'}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          key={`filter-role-all`}
          onClick={e => {
            e.preventDefault();
            props.filterType();
          }}
          disabled={props.disabled}
        >
          全部分類
          </DropdownItem>
        {types}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}



export default DropdownSelection